import {edgeServer} from '../api_client/apiClient';

const per = 10;
const page_size = 5;

export function getThreads(token){
  return(dispatch)=>{
    let url = `console/forum/threads?per=${per}&page_size=${page_size}`+(token?`&token=${token}`:'');
    edgeServer.get(url)
    .then((res)=>{
      dispatch({
        type: "GET_THREADS_FULFILLED",
        payload: res.data.data
      });
      // i really hate this part of the code but can't solve it without talking to james
      if(res.data.data.next_token != null){
        let new_token = res.data.data.next_token;
        let newUrl = `console/forum/threads?per=${per}&page_size=${page_size}&token=${new_token}`;
        edgeServer.get(newUrl)
        .then((res2)=>{
          dispatch({
            type: "UPDATE_PAGE_LENGTH",
            payload: res2.data.data,
            currentToken: new_token
          });
        });
      }
    })
    .catch((err)=>{
      dispatch({
        type:"GET_THREADS_REJECTED"
      });
    });
  };
}

export function setToken(token){
  return(dispatch)=>{
    dispatch({
      type: "SET_TOKEN",
      payload: token
    });
  };
}

export function getThreadDetail(threadId){
  return(dispatch)=>{
    edgeServer.get(`console/forum/threads/${threadId}`)
    .then((response)=>{
      dispatch({type:"GET_THREAD_DETAIL_FULFILLED", payload: response.data.data});
    })
    .catch((err)=>{
      dispatch({type:"GET_THREAD_DETAIL_REJECTED", payload: err});
    });
  };
}

export function getOnlyThread(threadId){
  return(dispatch)=>{
    edgeServer.get(`console/forum/threads/${threadId}`)
    .then((response)=>{
      dispatch({type:"GET_ONLY_THREAD_FULFILLED", payload: response.data.data});
    })
    .catch((err)=>{
      dispatch({type:"GET_THREAD_DETAIL_REJECTED", payload: err});
    });
  };
}

export function postThread(content){
  return(dispatch)=>{
    edgeServer.post('/console/forum/threads', content, {headers:{'Content-Type':'application/json'}})
    .then((response)=>{
      dispatch({type:"POST_THREAD_FULFILLED", payload: response.data.data.thread_id});
    })
    .catch((err)=>{
      alert(err);
    });
  };
}

export function editThread(content, threadId){
  return(dispatch)=>{
    edgeServer.post(`/console/forum/threads/${threadId}/put`,content, {headers:{'Content-Type':'application/json'}})
    .then((response)=>{
      dispatch({type:"EDIT_THREAD_FULFILLED"});
    })
    .catch((err)=>{
      dispatch({type:"EDIT_THREAD_REJECTED", payload:err});
    });
  };
}

// Implemented deleteThread in the container
// export function deleteThread(threadId){
//   return(dispatch)=>{
//     edgeServer.delete(`/console/forum/threads/${threadId}`)
//     .then((res)=>{
//       dispaych({type:"DELETE_THREAD_FULFILLED"});
//     }).catch((err)=>{
//       dispatch({type:"DELETE_THREAD_REJECTED", payload:err});
//     })
//   }
// }

function getComments(threadId){
  return(dispatch)=>{
    edgeServer.get(`console/forum/threads/${threadId}/comments`)
    .then((res)=>{
      dispatch({type:"GET_COMMENTS_FULFILLED", payload: res.data.data.comments});
    }).catch((err)=>{
      dispatch({type:"GET_COMMENT_REJECTED", payload: err});
    });
  };
}

export function postComment(content,threadId){
  return(dispatch)=>{
    edgeServer.post(`console/forum/threads/${threadId}/comments`,
      content, {headers:{'Content-Type':'application/json'}}
    ).then((response)=>{
      dispatch({type:"POST_COMMENT_FULFILLED"});
      dispatch(getComments(threadId));
    }).catch((err)=>{
      dispatch({type:"POST_COMMENT_REJECTED", payload: err});
    });
  };
}

export function deleteComment(commentId,threadId){
  return(dispatch)=>{
    edgeServer.post(`console/forum/comments/${commentId}/delete`)
    .then((response)=>{
      dispatch({type:"DELETE_COMMENT_FULFILLED"});
      alert("この返信は削除されました。");
      dispatch(getComments(threadId));
    }).catch((err)=>{
      dispatch({type:"DELETE_COMMENT_REJECTED", payload: err});
    });
  };
}

export function editComment(content, commentId,threadId){
  return(dispatch)=>{
    edgeServer.post(`console/forum/comments/${commentId}/put`,
      content, {hearders:{'Content-Type':'application/json'}}
    ).then((response)=>{
      dispatch({type:"EDIT_COMMENT_FULFILLED"});
      dispatch(getComments(threadId));
    }).catch((err)=>{
      dispatch({type:"EDIT_COMMENT_REJECTED", payload: err});
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/SupportAction.js